const ErrorCodes = {
  UNAUTHORIZED: 4000,
  SESSION_EXPIRED: 4001,
  UNAUTHORIZED_USER_ACCESS: 4005,
  UNAUTHORIZED_TENANT_USER_ACCESS: 4006,
  GENERIC: 5000,
  PROPERTY_NOT_FOUND: 5001,
  ENTITY_NOT_FOUND: 5002,
  INVALID_EMAIL: 5003,
  INVALID_FIELDS: 5004,
  USER_EXISTS: 6000,
};

export default ErrorCodes;
